export default {
    'Intelligent-Categorization-Import': '元字段导入',
    'Click or drag file to this area to upload': '点击或拖动文件到此区域进行上传',
    'upload info': '请上传 excel格式文件。严禁上传其他违禁文件',
    'Or paste your file link': '或粘贴你的文件连接',
    'Import': '导入',
    'Help': '帮助',
    'Steps': '步骤',
    'Download Template': '下载模板',
    'Prepare data according to the template': '按照模板准备数据',
    'Upload your prepared data': '上传你准备好的数据',
    'The system is executing the import': '系统执行导入',
    'Operation completed': '完成操作',
    'Contact us': '联系我们',
    'If you have any questions or suggestions, please feel free to contact us': '如果您有任何问题或建议，请随时联系我们',
    'Phone': '电话',
    'Smart Categorization Import': '元字段导入',
    'Download Template Now': '立即下载模板',
    'help.doc.title': '帮助文档',
    'Export': '导出',
    'Smart categorization': '元字段',
    'Click a button to export smart categorization data': '点击按钮导出元字段数据',
    'Custom Collections':'手动分类',
    "Export manually classified IDs": "导出手动分类的ID",
    "Smart Collections": "智能分类",
    "Export smart classified IDs": "导出智能分类的ID",
    "Exporting products": "导出产品",
    "Exporting product ID and variant ID": "导出商品的ID 和Variant ID",
    
    // 新增的翻译
    'Home': '首页',
    'Welcome': '欢迎使用智能导入系统',
    'Please select the function you want to use': '请选择您要使用的功能',
    'Metafields Import': '元字段导入',
    'Import metafields data to your store': '将元字段数据导入到您的商店',
    'Product Template Import': '商品模板导入',
    'Batch import product templates and collections': '批量导入商品模板和商品分类',
    'Operation Logs': '操作日志',
    'View operation logs and task status': '查看操作日志和任务状态',
    'Recent Activity': '最近活动',
    'No recent activity': '暂无最近活动',
    'Smart Import System': '智能导入系统',
    
    // 产品导入页面
    'Collection Template Import': '分类模板导入',
    'Support CSV, Excel format files': '支持 CSV、Excel 格式文件',
    'Task Status': '任务状态',
    'Task ID': '任务ID',
    'Type': '类型',
    'Status': '状态',
    'Created Time': '创建时间',
    'Action': '操作',
    'Refresh': '刷新',
    'Product Import Steps': '商品导入步骤',
    'Download product template': '下载商品模板',
    'Prepare product data according to template': '根据模板准备商品数据',
    'Upload prepared product file': '上传准备好的商品文件',
    'Wait for import completion': '等待导入完成',
    'Download Product Template': '下载商品模板',
    'Collection Import Steps': '分类导入步骤',
    'Download collection template': '下载分类模板',
    'Prepare collection data according to template': '根据模板准备分类数据',
    'Upload prepared collection file': '上传准备好的分类文件',
    'Download Collection Template': '下载分类模板',
    'Please enter file URL': '请输入文件链接',
    'Task submitted successfully': '任务提交成功',
    'Import failed': '导入失败',
    'Product template download feature coming soon': '商品模板下载功能即将上线',
    'Collection template download feature coming soon': '分类模板下载功能即将上线',
    
    // 新增任务状态相关翻译
    'File URL': '文件链接',
    'Progress': '进度',
    'Results': '结果',
    'Total': '总计',
    'COMPLETED': '已完成',
    
    // 日志页面
    'Total Logs': '总日志数',
    'Success': '成功',
    'Failed': '失败',
    'Pending': '待处理',
    'Filter': '筛选',
    'Resource Type': '资源类型',
    'All': '全部',
    'Product': '商品',
    'Collection': '分类',
    'Start Time': '开始时间',
    'End Time': '结束时间',
    'Select start time': '选择开始时间',
    'Select end time': '选择结束时间',
    'Search': '搜索',
    'Reset': '重置',
    'Cleanup Old Logs': '清理旧日志',
    'Log List': '日志列表',
    'ID': 'ID',
    'Resource ID': '资源ID',
    'Error Message': '错误信息',
    'View Detail': '查看详情',
    'None': '无',
    'No details': '无详情',
    'Log Detail': '日志详情',
    'Details': '详情',
    'Updated Time': '更新时间',
    'Confirm': '确认',
    'Are you sure to cleanup old logs? This action cannot be undone.': '确定要清理旧日志吗？此操作不可撤销。',
    'Cleanup completed': '清理完成',
    'Cleanup failed': '清理失败',
    'PENDING': '待处理',
    'PROCESSING': '处理中',
    'STALLED': '疑似卡住',
    'SUCCESS': '成功',
    'FAILED': '失败',
    'Task may be stalled': '任务可能已卡住',
    'Task processing time exceeded threshold, please retry this file if status does not change': '任务处理时间超过阈值，若状态持续不变请重新提交该文件',
    'PRODUCT': '商品',
    'COLLECTION': '分类',
    
    // 价格页面
    'Pricing Plans': '价格方案',
    'Choose the plan that fits your business needs': '选择适合您业务需求的方案',
    'Usage Limit Exceeded': '使用限制已超出',
    'You have exceeded your monthly usage limit': '您已超出月度使用限制',
    'Recommended': '推荐',
    'Free Plan': '免费版',
    'Basic Plan': '基础版',
    'Professional Plan': '专业版',
    'Enterprise Plan': '企业版',
    'month': '月',
    'Current Plan': '当前套餐',
    'Select Plan': '选择套餐',
    'Feature Comparison': '功能对比',
    'Feature': '功能',
    'Need Help Choosing?': '需要选择帮助？',
    'Contact us for personalized recommendations and enterprise solutions': '联系我们获取个性化建议和企业解决方案',
    'Contact Sales': '联系销售',
    'Monthly 10 uses limit': '每月10次使用限制',
    'Basic functionality support': '基础功能支持',
    'Metafields import only (no export)': '仅支持元字段导入（不含导出）',
    'Community support': '社区支持',
    'Monthly 100 uses limit': '每月100次使用限制',
    'All features except collection updates': '除集合更新外的所有功能',
    'Includes metafields export': '包含元字段导出功能',
    'Email support': '邮件支持',
    'Unlimited usage': '无限制使用',
    'All features support': '所有功能支持',
    'Priority technical support': '优先技术支持',
    'API access': 'API访问',
    'Dedicated customer service': '专属客服',
    'Custom development': '定制开发',
    'SLA guarantee': 'SLA保障',
    'Usage Limit': '使用限制',
    '10/month': '10次/月',
    '100/month': '100次/月',
    'Unlimited': '无限制',
    'Metafields Import': '元字段导入',
    'Product Import': '商品导入',
    'Collection Import': '分类导入',
    'API Access': 'API访问',
    'Support Level': '支持级别',
    'Community': '社区',
    'Email': '邮件',
    'Priority': '优先',
    'Dedicated': '专属',
    'You are currently on the free plan': '您当前使用的是免费套餐',
    'Plan upgrade request submitted': '套餐升级请求已提交',
    'Please contact our sales team for subscription': '请联系我们的销售团队进行订阅',
    'Monthly usage limit exceeded': '月度使用限制已超出。当前已使用: {current}/{limit}，本次请求: {request}',
    'Upgrade your plan to continue': '升级您的套餐以继续使用我们的服务',
    'View Pricing': '查看价格',
    'Cancel': '取消',
    'Current usage': '当前使用',
    'This request': '本次请求',
    
    // 支付页面
    'Payment': '支付',
    'Selected Plan': '选择的套餐',
    'Included Features': '包含功能',
    'Payment Methods': '支付方式',
    'Alipay': '支付宝',
    'WeChat Pay': '微信支付',
    'Scan QR code to pay with Alipay': '扫描二维码使用支付宝付款',
    'Scan QR code to pay with WeChat': '扫描二维码使用微信付款',
    'Need Help?': '需要帮助？',
    'Customer Service WeChat': '客服微信',
    'Contact our customer service for:': '联系我们的客服获取：',
    'Contact our customer service for payment confirmation and account activation': '联系我们的客服进行付款确认和账户激活',
    'Payment confirmation': '付款确认',
    'Account activation': '账户激活',
    'Technical support': '技术支持',
    'Refund requests': '退款申请',
    'Payment Instructions': '支付说明',
    '1. Please include your email address in the payment note': '1. 请在付款备注中包含您的邮箱地址',
    '2. Account will be activated within 24 hours after payment confirmation': '2. 付款确认后24小时内激活账户',
    '3. Contact customer service if you need immediate activation': '3. 如需立即激活请联系客服',
    '4. Refunds are available within 7 days if unsatisfied': '4. 如不满意可在7天内申请退款',
    'Back to Pricing': '返回价格页面',
    
    // 日志页面新增翻译
    'Operation': '操作',
    'None': '无',
    'No details': '无详情',
    'Log Detail': '日志详情',
    'Log List': '日志列表',
    'Select start time': '选择开始时间',
    'Select end time': '选择结束时间',
    'Cleanup Old Logs': '清理旧日志',
    'Are you sure to cleanup old logs? This action cannot be undone.': '确定要清理旧日志吗？此操作无法撤销。',
    'Cleanup completed': '清理完成',
    'Cleanup failed': '清理失败',
    'Handle': '句柄',
    'Request Data': '请求数据',
    'Response Data': '响应数据',
    'UPDATE': '更新',
    'CREATE': '创建',
    'DELETE': '删除',
    'Success Rate': '成功率',
    'Products': '产品',
    'Collections': '集合',
    'Pricing Plans': '定价套餐',
    'View our pricing plans and upgrade': '查看我们的定价套餐并升级',
    'Product template download started': '商品模板下载已开始',
    'Collection template download started': '分类模板下载已开始',
    'Download product template': '下载商品模板',
    'Download collection template': '下载分类模板',
    'Prepare product data according to template': '根据模板准备商品数据',
    'Download Product Template': '下载商品模板',
    'Download Collection Template': '下载分类模板',
    'Metafields Import': '元字段导入',
    'Support Excel format files (.xlsx)': '支持Excel格式文件 (.xlsx)',
    'Metafields Import Steps': '元字段导入步骤',
    'Download metafields template': '下载元字段模板',
    'Prepare metafields data according to template': '根据模板准备元字段数据',
    'Upload prepared metafields file': '上传准备好的元字段文件',
    'Wait for import completion': '等待导入完成',
    'Download Metafields Template': '下载元字段模板',
    'Template Format': '模板格式',
    'Excel file with 8 columns:': 'Excel文件包含8列：',
    'Owner Resource': '所有者资源',
    'Owner ID': '所有者ID',
    'Parent ID': '父ID',
    'Namespace': '命名空间',
    'Key': '键名',
    'Type': '类型',
    'Description': '描述',
    'Value': '值',
    'View Logs': '查看日志',
    'Statistics': '统计信息',
    'Import Logs': '导入日志',
    'Import Statistics': '导入统计',
    'Row Number': '行号',
    'Total Records': '总记录数',
    'Success Count': '成功数量',
    'Failed Count': '失败数量',
    'Start Time': '开始时间',
    'End Time': '结束时间',
    'Template download started': '模板下载已开始',
    'Template download failed': '模板下载失败',
    'Please refer to the template format in help section': '请参考帮助部分的模板格式',
    'Import metafields data to your store': '导入元字段数据到您的商店',
    'No statistics data available': '无统计数据可用',
    'Failed to load statistics': '加载统计信息失败',
    'View Field Guide': '查看字段指南',
    'Metafield Field Guide': '元字段字段指南',
    'The resource type that the metafield belongs to. Valid enum values include:': '元字段所归属的资源类型。有效枚举值包含：',
    'Product variants': '商品变体',
    'Product collections': '商品分类',
    'Customers': '会员',
    'Orders': '订单',
    'Pages': '页面',
    'Blog collections': '博客集合',
    'Blog articles': '博客',
    'Shop': '店铺',
    'Metafield Type': '元字段类型',
    'Data types supported by metafields. Valid enum values include:': '元字段支持的数据类型，有效枚举值包含：',
    'Text Types': '文本类型',
    'Single line text': '单行文本',
    'Multiple single line texts': '多个单行文本',
    'Multi-line text': '多行文本',
    'Color Types': '颜色类型',
    'Single color': '单个颜色',
    'Multiple colors': '多个颜色',
    'Date Types': '日期类型',
    'Single date': '单个日期',
    'Multiple dates': '多个日期',
    'Single date and time (ISO 8601 format)': '单个日期和时间（ISO 8601格式）',
    'Multiple dates and times (ISO 8601 format)': '多个日期和时间（ISO 8601格式）',
    'URL Types': 'URL类型',
    'Single URL': '单个URL',
    'Multiple URLs': '多个URL',
    'File Types': '文件类型',
    'Single file (PDF, JPG, JPEG, PNG, GIF up to 10MB)': '单个文件（支持10M以内的PDF和图片文件，图片支持JPG、JPEG、PNG和GIF格式）',
    'Multiple files (PDF, JPG, JPEG, PNG, GIF up to 10MB)': '多个文件（支持10M以内的PDF和图片文件，图片支持JPG、JPEG、PNG和GIF格式）',
    'Number Types': '数字类型',
    'Single integer': '单个整数',
    'Multiple integers': '多个整数',
    'Single decimal': '单个小数',
    'Multiple decimals': '多个小数',
    'Measurement Types': '测量类型',
    'Single weight with unit': '单个重量，带单位',
    'Multiple weights with units': '多个重量，带单位',
    'Single volume with unit': '单个体积，带单位',
    'Multiple volumes with units': '多个体积，带单位',
    'Single dimension with unit': '单个尺寸，带单位',
    'Multiple dimensions with units': '多个尺寸，带单位',
    'Reference Types': '引用类型',
    'Single page reference': '单个页面',
    'Multiple page references': '多个页面',
    'Single product reference': '单个商品',
    'Multiple product references': '多个商品',
    'Single variant reference': '单个商品变体',
    'Multiple variant references': '多个商品变体',
    'Single collection reference': '单个商品分类',
    'Multiple collection references': '多个商品分类',
    'Single customer reference': '单个客户',
    'Multiple customer references': '多个客户',
    'Single order reference': '单个订单',
    'Multiple order references': '多个订单',
    'Other Types': '其他类型',
    'JSON type': 'JSON类型',
    'Single rating': '单个等级',
    'Multiple ratings': '多个等级',
    'Boolean type (true/false)': '布尔类型（true/false）',
    'Money with currency unit': '资金，带币种单位',
    'Value Format Guide': 'Value 格式说明',
    'Different metafield types require different value formats. See the table below:': '不同元字段类型对 value 的格式要求不同，详见下表：',
    'list type prerequisite title': '⚠️ 使用 list.* 类型前必须先在后台创建元字段定义',
    'list type prerequisite desc': '所有 list.* 类型（如 list.single_line_text_field）在导入前，必须先在 Shopline 管理后台 → 设置 → 自定义数据 中创建对应的元字段定义，并将赋值类型设置为「多个值」。未提前创建定义时，API 不会报错，但数据不会写入。',
    'Metafields Export': '元字段导出',
    'Export metafields to Excel': '将元字段数据导出为 Excel',
    'Export metafields from your store to Excel file for backup or re-import': '将店铺元字段导出为 Excel 文件，可用于备份或再次导入',
    'Resource Type': '资源类型',
    'Select resource type': '请选择资源类型',
    'Metafield Type Filter (optional)': '元字段类型过滤（可选）',
    'Namespace (optional)': '命名空间（可选）',
    'Key (optional)': '键名（可选）',
    'Input namespace (e.g. custom_fields)': '请输入命名空间（例如：custom_fields）',
    'Input key (e.g. material)': '请输入键名（例如：material）',
    'All types (no filter)': '全部类型（不过滤）',
    'Start Export': '开始导出',
    'Exporting...': '导出中…',
    'Export Progress': '导出进度',
    'Task Created': '任务已创建',
    'Fetching Data': '拉取数据',
    'Generating File': '生成文件',
    'Processed': '已处理',
    'Total metafields': '元字段总条数',
    'Export completed!': '导出完成！',
    'Click the button below to download the Excel file': '点击下方按鈕下载 Excel 文件',
    'Download Excel': '下载 Excel',
    'Export failed': '导出失败',
    'Cancel Export': '取消导出',
    'Export cancelled': '导出已取消',
    'Are you sure you want to cancel this export task?': '确定要取消此导出任务吗？',
    'The export task has been cancelled': '导出任务已被取消',
    'Export task cancelled': '导出任务已取消',
    'Failed to cancel export': '取消导出失败',
    'Instructions': '使用说明',
    'export_step_1': '选择需要导出的资源类型（如：商品、变体）',
    'export_step_2': '可按类型过滤，或指定 namespace + key 精确导出；都不填则导出全部类型',
    'export_step_3': '点击「开始导出」，等待任务完成',
    'export_step_4': '任务完成后点击「下载 Excel」下载文件，可直接用于导入功能',
    'export_warning_title': '注意：导出时间',
    'export_warning_desc': '导出速度取决于店铺内资源数量和元字段条数。商品数量较大时，导出可能需要几分钟，请耐心等待。',
    'Export task started': '导出任务已启动',
    'Failed to start export': '启动导出失败',
    'Please select a resource type': '请选择资源类型',
    'Store handle not found, please re-login': '未找到店铺标识，请重新登录',
    'Request failed': '请求失败',
    'Please fill both namespace and key': '请同时填写命名空间和键名',
    'Metafields export requires Basic plan or above': '元字段导出需基础版及以上套餐',

    // 商品批量更新模块
    'Product Batch Management': '商品批量管理',
    'Batch import product templates, collections and update products via CSV/Excel': '通过 CSV/Excel 批量导入商品模板、合集，并更新商品信息',
    'Product Batch Update': '商品批量更新',
    'Update Tags Only': '仅更新 Tags',
    'Update Full Product': '更新全部字段',
    'Update Type': '更新类型',
    'Start Update': '开始更新',
    'Product Update Task Status': '商品更新任务状态',
    'Product Tag Update Tip': 'CSV 只需两列：product_id（Shopline 商品 ID）、tags（必须小写，英文逗号分隔）。本模式不会改动其他字段。',
    'Product Full Update Tip': 'CSV 可包含 product_id、title、tags、description、spu 等字段。空值字段会被跳过；不会修改的字段请留空。',
    'Product Update Steps': '商品更新步骤',
    'Download product update template': '下载商品更新模板',
    'Download Product Tag Template': '下载商品标签模板',
    'Download Product Full Template': '下载商品全量模板',
    'Wait for update completion': '等待更新完成',
    'Update product tags or other fields in bulk via CSV/Excel': '通过 CSV/Excel 批量更新商品 tag 或其他字段',
    'CSV header normalized to lowercase tags': 'CSV 表头已自动归一化为小写 tags'
  }
  


// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/index.js